const AR = {
  title: 'الدفع',
  cardHolderName: 'اسم حامل البطاقة',
  cardHolderNamePlaceholder: 'أدخل اسم حامل البطاقة',
  cardNumber: 'رقم البطاقة',
  cardNumberPlaceholder: 'أدخل رقم البطاقة',
  expiryDate: 'تاريخ انتهاء الصلاحية',
  expiryDateHelperText:
    'يجب أن تكون قادرًا على العثور على هذا التاريخ على مقدمة بطاقتك ، تحت رقم البطاقة',
  cvv: 'رمز الأمان',
  cvvHelperText:
    'الرمز الموجود على بطاقتك الائتمانية يمكنك العثور عليه على ظهر بطاقتك',
  cvvPlaceholder: '123',
  rememberMeText: 'حفظ بيانات البطاقة للدفع السريع والآمن',
  total: 'السعر الإجمالي',
  taxes: ' ( شامل الضريبة و التوصيل )',
  payNow: 'ادفع الآن',
  transactionFailedTitle: 'فشلت المعاملة',
  transactionFailedText:
    'مبلغ المعاملة إما أكبر من الحد الأقصى أو أقل من الحد الأدنى للمبلغ المقبول للخطة المحددة',
  transactionFailedAction: 'جرب مرة أخرى',
  informativeModalButtonText: 'تم',
  required: 'مطلوب',
  cardNameCharactersValidation: 'يجب ان يحتوي الاسم علي حروف فقط',
  cardFullNameValidation: 'يجب ان يحتوي على أسمين على الاقل',
  expiryDateValidation: 'البطاقة منتهية الصلاحية',
  invalidDate: 'تاريخ خاطئ',
  cvv_invalid: 'رمز الأمان خطأ',
  card_number_invalid: 'رقم البطاقة خاطئ',
  plan_price: 'سعر الباقة',
  vat: 'ضريبة القيمة المضافة',
  promoted_bank_discount:
    'خصم {{promotedBankName}} {{discountAmount}}{{type}}، {{extraNote}}',
  program_discount: 'خصم الشركات',
  addon: 'إضافة',
  wallet: 'المحفظة',
  rajhi_mokafaa: 'مكافأة الراجحي',
};
export default AR;
